<template>
  <div>
    <side-menu
      title="Услуга"
      :value="open"
      @side-menu:click-close="onClose"
    >
      <div>
        <custom-select
          v-model="selectedValues.service"
          class="mb-8"
          label="Вид услуги"
          :items="serviceItems"
          scroll
          search
          mandatory
        />

        <custom-select
          v-model="selectedValues.sort"
          class="mb-8"
          label="Сортировка"
          :items="sortItems"
          mandatory
        />
      </div>

      <div class="filters-service__buttons">
        <v-button
          color="text-secondary"
          :disabled="!active && !innerFiltersActive"
          depressed
          text
          light
          @click="reset"
        >
          <span class="text-button">Сбросить</span>
        </v-button>

        <v-button
          class="ml-4"
          color="primary"
          depressed
          @click="submit"
        >
          <span class="text-button">Показать</span>
        </v-button>
      </div>
    </side-menu>
  </div>
</template>

<script>
import VButton from 'www/vue_components/common/core/VButton.vue'
import CustomSelect from 'www/vue_components/desktop/core/CustomSelect.vue'
import DialogManager from 'www/vue_components/common/mixins/DialogManager'
import SideMenu from 'www/vue_components/desktop/core/SideMenu.vue'

export default {
  name: 'ServiceFiltersService',
  components: {
    VButton,
    SideMenu,
    CustomSelect,
  },
  mixins: [
    DialogManager,
  ],
  model: {
    prop: 'filters',
    event: 'change',
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedValues: {
        service: '',
        sort: '',
      },
    }
  },
  computed: {
    innerFiltersActive() {
      return this.selectedValues.service !== this.filters.service.value
            || this.selectedValues.sort !== this.filters.sort.value
    },
    serviceItems() {
      return this.makeListItems(this.filters.service.type)
    },
    sortItems() {
      return this.makeListItems(this.filters.sort.type)
    },
  },
  watch: {
    filters: {
      immediate: true,
      deep: true,
      handler() {
        this.innerReset()
      },
    },
  },
  methods: {
    onBack() {
      this.closeDialog()
    },
    onClose() {
      this.$emit('filters:close')
      this.innerReset()
    },
    innerReset() {
      this.selectedValues.service = this.filters.service.value
      this.selectedValues.sort = this.filters.sort.value
    },
    reset() {
      if (this.active) {
        this.$emit('filters:reset')

        return
      }

      this.innerReset()
    },
    submit() {
      this.$emit('filters:submit', this.selectedValues)
      this.$emit('filters:close')
    },
    makeListItems(filterType) {
      return filterType.getList().map(filterOption => ({
        value: filterOption.value,
        id: filterOption.value,
        text: filterOption.name,
      }))
    },
  },
}
</script>

<style lang="scss" scoped>
.filters-service {
  display: flex;
  flex-flow: column nowrap;

  &__section-item {
    flex: 1 1 0;
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }
  }

  &__buttons {
    margin-top: auto;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
